<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin],
  methods: {
    expandUrl: Fandom.expandUrl,
    exists: Fandom.exists,
    getContentResponsiveImageURL: Fandom.getContentResponsiveImageURL
  },
  computed: {
    contentStyle() {
      const style = {};
      const imageUrl = this.getContentResponsiveImageURL('background_image');
      if (!!imageUrl) {
        style["background-image"] = imageUrl;
      }
      if (this.content.background_color) {
        style["background-color"] = this.content.background_color;
      }
      return style;
    }
  },
};

</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" v-if="isContentVisibleToUser()" class="mx-3 mx-md-0 py-4 py-md-5" stripe-launch-component>
    <span v-if="content.stripe_id" class="anchor" :id="content.stripe_id"></span>
    <div class="container tile-shadow" :style="contentStyle">
      <div class="row">
        <div class="col-12 col-md-6 px-4 px-md-5 py-4 py-md-5">
          <h3 class="font-weight-light mb-4" :class="content.title_class || 'h3 text-primary'" v-if="content.title">{{content.title}}</h3>
          <p :class="content.description_tag" v-if="content.description" v-html="content.description"></p>
          <a class="btn mt-4" :href="content.button.url" :target="getTarget(content.button)" v-if="content.button" :class="content.button_class || 'btn-primary'">
            {{content.button.title}}
          </a>
          <p class="text-primary mt-4" v-if="content.disclaimer" v-html="content.disclaimer"></p>
        </div>
        <div class="col-12 col-md-6 px-0" v-if="content.image">
          <img :src="content.image.url" class="w-100"/>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
[stripe-launch-component] {

  & > div {
    border-radius: 6px;
  }

}
</style>